// @flow
import React from 'react';
import { translate } from 'react-i18next';
import styled from 'styled-components';
import { Spacer } from 'statsradio/themes/v3/Stylesheet';
import { type MetricType, type Period } from '../../../domain/DashboardData';
import AudienceComparisonWeek from './AudienceComparisonWeek';
import WeekendMetrics from './WeekendMetrics';

const SpacerContainer = styled.div`
  display: flex;
  padding-left: ${props => props.theme.V3.metrics.margin.small}px;
  padding-right: ${props => props.theme.V3.metrics.margin.large}px;
`;

const AudienceComparisonSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: ${props => props.flexGrow || 0};
`;

interface Props {
  metricType: MetricType;
  period: Period;
  data: Object;
  t: any;
}

function AudienceComparisonContent({ metricType, period, data, t }: Props) {
  const comparedDataByTimeInterval = metricType === 'reach' ? data.comparedReachByTimeInterval : data.comparedListeningTimeByTimeInterval;
  const saturdayComparedMetric = metricType === 'reach' ? data.saturdayComparedReach : data.saturdayComparedListeningTime;
  const sundayComparedMetric = metricType === 'reach' ? data.sundayComparedReach : data.sundayComparedListeningTime;

  return (
    <React.Fragment>
      <AudienceComparisonSection flexGrow="1">
        <AudienceComparisonWeek period={period} metricType={metricType} comparedDataByTimeInterval={comparedDataByTimeInterval} />
      </AudienceComparisonSection>
      <SpacerContainer>
        <Spacer />
      </SpacerContainer>
      <AudienceComparisonSection>
        <WeekendMetrics type={metricType} saturdayComparedMetric={saturdayComparedMetric} sundayComparedMetric={sundayComparedMetric} />
      </AudienceComparisonSection>
    </React.Fragment>
  );
}

export default translate('dashboard')(AudienceComparisonContent);



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/v2/components/audienceComparison/AudienceComparisonContent.js